import styled from 'styled-components';

interface IProps {
	error: Error | null;
}

const Element = styled.p`
	color: ${(props) => props.theme.colors.danger};
	padding-top: 6px;
`;

export function FormErrorMessage(props: IProps) {
	const { error } = props;

	return <Element>{error?.message}</Element>;
}
